import { render } from "./groupContainer.vue?vue&type=template&id=3411913c&scoped=true"
import script from "./groupContainer.vue?vue&type=script&lang=js"
export * from "./groupContainer.vue?vue&type=script&lang=js"

import "./groupContainer.vue?vue&type=style&index=0&id=3411913c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3411913c"]])

export default __exports__